var externalObj = {
    Id: 0,
    T_name: "自己",
}
export default externalObj;